module.exports = __webpack_public_path__ + "img/Theme.63cceaa2.svg";